"use client";

import NavList from "../NavList";
import MyProjects from "../MyProjects";
import CoverImage from "../CoverImage";

const Projects = () => {
  return (
    <>
      <CoverImage />

      <NavList />

      <MyProjects />
    </>
  );
};

export default Projects;
